<app-document-viewer-page navigateTo="/home" label="Pago de Fianza" [url]="checkoutUrl">
</app-document-viewer-page>
